import React from 'react';

const Client = () => {
  return (
    <>
      <h1 style={{ textAlign: 'center' }}>Clients</h1>
    </>
  );
};

export default Client;